export default {
}



// WEBPACK FOOTER //
// ./src/app/tenant/meeting/index/resources/computed.js